import { MetalLevel } from '@zorro/clients';
import { $enum } from 'ts-enum-util';

export const getMetalLevelLabel = (metalLevel?: MetalLevel | null): string => {
  return $enum.mapValue(metalLevel).with({
    [MetalLevel.EXPANDED_BRONZE]: 'Bronze',
    [MetalLevel.CATASTROPHIC]: 'Catastrophic',
    [MetalLevel.PLATINUM]: 'Platinum',
    [MetalLevel.BRONZE]: 'Bronze',
    [MetalLevel.SILVER]: 'Silver',
    [MetalLevel.GOLD]: 'Gold',
    [$enum.handleUnexpected]: '',
    [$enum.handleUndefined]: '',
    [$enum.handleNull]: '',
  });
};
